<div fxLayout="row" fxFlexFill id="dashboard">
  <div
    class="sidebar mat-elevation-z1"
    [ngStyle]="{ width: sidebarCollapse ? '60px' : '280px' }"
  >
    <!-- [ngStyle]="sidebarCollapse && { width: '60px' }" -->
    <div
      class="mat-elevation-z1 sidebar-header"
      fxLayout="row"
      fxLayoutAlign="space-around center"
      *ngIf="!sidebarCollapse"
    >
      <img
        src="../../assets/heartcare_logo.png"
        style="height: 45px; width: 45px; padding-left: 8px"
      />
      <div class="mat-title sidebar-title" fxFlex="70" *ngIf="!sidebarCollapse">
        HeartCare
      </div>
      <div>
        <i
          class="toggler material-icons"
          *ngIf="!sidebarCollapse"
          (click)="sidebartoggler()"
        >
          menu
        </i>
      </div>
    </div>

    <div
      class="mat-elevation-z1 sidebar-header"
      *ngIf="sidebarCollapse"
      fxLayout="row"
      fxLayoutAlign="space-around center"
    >
      <div>
        <i class="toggler-close material-icons" (click)="sidebartoggler()">
          menu
        </i>
      </div>
    </div>

    <div class="nav" fxLayout="column" fxLayoutGap="5px">
 

  <!-- // Dashboard  -->
  <div fxLayout="column">
    <a
    *ngIf="!sidebarCollapse"
      (click)="toggleDashboard()"
      fxLayout="row"
      fxLayoutAlign="center center"
      class="nav-link sidenav-items"
      [ngClass]="!this.dashboardExpanded && this.dashboardActive ? 'active-link':''"

    >
      <div  style="cursor: pointer;" fxFlex="20">
        <mat-icon aria-hidden="false" *ngIf="!sidebarCollapse"  class="nav-link-icon sidebar-icon" aria-label="menu icon"
          >dashboard</mat-icon>
      </div>
       <div  style="cursor: pointer;" 
      *ngIf="!sidebarCollapse" fxFlex="60">
         <span>Dashboard</span>
       </div> 
  
          <mat-icon *ngIf="!sidebarCollapse && dashboardExpanded"
           class="nested-icon" style="cursor: pointer;"
           >keyboard_arrow_up</mat-icon>
           <mat-icon *ngIf="!sidebarCollapse && !dashboardExpanded"
           class="nested-icon" style="cursor: pointer;"
           >expand_more</mat-icon>
       </a>

    <!-- Side nav collapsed - show dashboard icon -->
      <a
      *ngIf="sidebarCollapse"
      class="nav-link-icon icons"
      routerLink="home"
      routerLinkActive="active-link"
      class="nav-link"
      [ngClass]="this.dashboardActive ? 'active-link' : ''"
    >
      <mat-icon class="sidebar-icon" style="right: 0;">dashboard</mat-icon>
    </a>

      <div *ngIf="dashboardExpanded && !sidebarCollapse" fxLayout="column" fxLayoutGap="1%">
        <a
          class="nav-link"
          fxLayout="row"
          routerLink="/dashboard/home"
          routerLinkActive="active-link"
          fxFlex="60"
        >
          <div *ngIf="!sidebarCollapse" 
          style="cursor: pointer;"
          fxFlexOffset="20">
          <span class="nav-link-title">Assessment Summary
          </span>

      </div>
        </a>
        <a
          class="nav-link"
          fxLayout="row"
          fxFlex="60"
          routerLink="/dashboard/tobacco-cessation"
          routerLinkActive="active-link"
        >
          <div *ngIf="!sidebarCollapse" 
          style="cursor: pointer;"
          fxFlexOffset="20">
          <span class="nav-link-title">Tobacco Cessation
          </span>
        </div>
        </a>
      </div>

      </div>


      <!-- Users -->
      <div fxLayout="column" (click)="nav_check_fun()">
        <a
          *ngIf="!sidebarCollapse"
          routerLink="users"
          routerLinkActive="active-link"
          class="nav-link"
        >
          <mat-icon class="nav-link-icon">account_circle</mat-icon>
          <span class="nav-link-title">Users</span>
        </a>
        <a
          *ngIf="sidebarCollapse"
          class="nav-link-icon icons"
          routerLink="users"
          routerLinkActive="active-link"
          class="nav-link"
        >
          <mat-icon class="material-icons sidebar-icon" style="margin-top: 1%"
            >account_circle</mat-icon
          >
        </a>
      </div>

      <div
        *ngIf="userType === 1 || userType === 2"
        fxLayout="column"
        (click)="nav_check_fun()"
      >
        <a
          *ngIf="!sidebarCollapse"
          routerLink="administrative"
          routerLinkActive="active-link"
          class="nav-link"
        >
          <mat-icon class="nav-link-icon">location_on</mat-icon>
          <span class="nav-link-title">Administrative Divisions</span>
        </a>
        <a
          *ngIf="sidebarCollapse"
          class="nav-link-icon icons"
          routerLink="administrative"
          routerLinkActive="active-link"
          class="nav-link"
        >
          <mat-icon class="material-icons sidebar-icon" style="margin-top: 1%"
            >location_on</mat-icon
          >
        </a>
      </div>

      <div
        *ngIf="userType === 1 || userType === 2"
        fxLayout="column"
        (click)="nav_check_fun()"
      >
        <a
          *ngIf="!sidebarCollapse"
          routerLink="population"
          routerLinkActive="active-link"
          class="nav-link"
        >
          <mat-icon class="nav-link-icon">donut_small</mat-icon>
          <span class="nav-link-title">Population Distribution</span>
        </a>
        <a
          *ngIf="sidebarCollapse"
          class="nav-link-icon icons"
          routerLink="population"
          routerLinkActive="active-link"
          class="nav-link"
        >
          <mat-icon class="material-icons sidebar-icon">donut_small</mat-icon>
        </a>
      </div>

      <div
      *ngIf="userType === 1 || userType === 2"
      fxLayout="column"
      (click)="nav_screen_site_fun()"
    >
      <a
        *ngIf="!sidebarCollapse"
        routerLink="campaign"
        routerLinkActive="active-link" 
        class="nav-link"
      >
        <mat-icon class="nav-link-icon">track_changes</mat-icon>
        <span class="nav-link-title">Screening Sites</span>
      </a>
      <a
        *ngIf="sidebarCollapse"
        class="nav-link-icon icons"
        routerLink="population"
        routerLinkActive="active-link"
        class="nav-link"
      >
        <mat-icon class="material-icons sidebar-icon">track_changes</mat-icon>
      </a>
    </div>
      
      <div
        *ngIf="userType === 1 || userType === 2"
        fxLayout="column"
        (click)="nav_service_mode_fun()"
      >
        <a
          *ngIf="!sidebarCollapse"
          routerLink="campaign"
          routerLinkActive="active-link" 
          class="nav-link"
        >
          <mat-icon class="nav-link-icon">campaign</mat-icon>
          <span class="nav-link-title">Service mode</span>
        </a>
        <a
          *ngIf="sidebarCollapse"
          class="nav-link-icon icons"
          routerLink="population"
          routerLinkActive="active-link"
          class="nav-link"
        >
          <mat-icon class="material-icons sidebar-icon">campaign</mat-icon>
        </a>
      </div>

      <div
      *ngIf="userType === 1 || userType === 2"
      fxLayout="column"
      (click)="nav_dashboard_site_fun()"
    >
      <a
        *ngIf="!sidebarCollapse"
        routerLink="campaign"
        routerLinkActive="active-link" 
        class="nav-link"
      >
        <mat-icon class="nav-link-icon">dashboard</mat-icon>
        <span class="nav-link-title">Population Health Dashboard</span>
      </a>
      <a
        *ngIf="sidebarCollapse"
        class="nav-link-icon icons"
        routerLink="population"
        routerLinkActive="active-link"
        class="nav-link"
      >
        <mat-icon class="material-icons sidebar-icon">dashboard</mat-icon>
      </a>
    </div>

      <div
        *ngIf="userType === 1 || userType === 2"
        fxLayout="column"
        (click)="open_nav(nav_check)"
      >
        <a *ngIf="!sidebarCollapse" class="nav-link">
          <mat-icon class="nav-link-icon">local_hospital</mat-icon>
          <span class="nav-link-title">Pharmacy</span>
          <mat-icon class="nested-icon" *ngIf="nav_check == 0"
            >keyboard_arrow_down</mat-icon
          >
          <mat-icon class="nested-icon" *ngIf="nav_check == 1"
            >keyboard_arrow_up</mat-icon
          >
        </a>
        <a *ngIf="sidebarCollapse" class="nav-link-icon icons" class="nav-link">
          <mat-icon class="material-icons sidebar-icon"
            >local_hospital</mat-icon
          >
        </a>
      </div>
      <div
        fxLayout="column"
        *ngIf="(userType === 1 || userType === 2) && nav_check == 1"
      >
        <a
          *ngIf="!sidebarCollapse"
          routerLink="medicines"
          routerLinkActive="active-link"
          class="nav-link"
        >
          <span class="side-nav">Medicines</span>
        </a>
      </div>
      <div
        fxLayout="column"
        *ngIf="(userType === 1 || userType === 2) && nav_check == 1"
      >
        <a
          *ngIf="!sidebarCollapse"
          routerLink="examinations_test"
          routerLinkActive="active-link"
          class="nav-link"
        >
          <span class="side-nav">Examinations & Tests</span>
        </a>
      </div>
      <div
        fxLayout="column"
        *ngIf="(userType === 1 || userType === 2) && nav_check == 1"
      >
        <a
          *ngIf="!sidebarCollapse"
          routerLink="interventions"
          routerLinkActive="active-link"
          class="nav-link"
        >
          <span class="side-nav">Interventions</span>
        </a>
      </div>
    </div>
  </div>
  
  <div class="container" fxLayout="column">
    <mat-toolbar
      fxLayout
      fxLayoutAlign="flex-end center"
      fxLayoutGap="30px"
      class="menu-bar mat-elevation-z1"
    >
      <h2 *ngIf="isDevMode" class="darkRed">TEST ENVIRONMENT</h2>

      <!-- <div style="flex: 0 1 90%"></div> -->
      <div class="user-role" fxLayoutAlign="start center">
        <div
          (click)="menuTrigger.openMenu()"
          fxLayout="column"
          fxLayoutAlign="space-between stretch"
        >
          <div class="user-name mat-body-1">
            {{ lastName | uppercase }}, {{ firstName }}
          </div>
          <!-- <div class="user-email mat-caption" *ngIf="middleName != undefined">
            {{ middleName }}
          </div> -->
          <div class="user-email mat-caption">
            {{ userEmail ? userEmail : contactNumber }}
          </div>
        </div>
        <div
          fxLayout="column"
          fxLayoutAlign="space-between stretch"
          style="margin-bottom: 10%"
        >
          <button
            #menuTrigger="matMenuTrigger"
            [matMenuTriggerFor]="menu"
            mat-icon-button
          >
            <mat-icon class="user-name">keyboard_arrow_down</mat-icon>
          </button>
        </div>
      </div>
    </mat-toolbar>

    <mat-menu #menu="matMenu" style="color: transparent">
      <!-- // Removed feature -->
      <!-- <button
        mat-menu-item
        (click)="countryconfigration()"
        *ngIf="userType == 1"
      >
        <mat-icon style="font-size: 14px; padding-top: 10px">language</mat-icon>
        <a class="menu-button"> Country configuration </a>
      </button> -->
      <button mat-menu-item (click)="myprofile()">
        <mat-icon style="font-size: 14px; padding-top: 10px"
          >account_box</mat-icon
        >
        <a class="menu-button"> My profile </a>
      </button>
      <button mat-menu-item (click)="changePassword()">
        <mat-icon style="font-size: 14px; padding-top: 10px">security</mat-icon>
        <a class="menu-button"> Change password </a>
      </button>
      <button mat-menu-item (click)="logout()">
        <mat-icon style="font-size: 14px; padding-top: 10px"
          >exit_to_app</mat-icon
        >
        <a class="menu-button"> Log Out </a>
      </button>
    </mat-menu>
    <div fxLayout="column" style="overflow-y: auto" cdkScrollable>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
